import { render } from "./Corretores.vue?vue&type=template&id=63a1d8dc&scoped=true"
import script from "./Corretores.vue?vue&type=script&lang=js"
export * from "./Corretores.vue?vue&type=script&lang=js"

import "./Corretores.vue?vue&type=style&index=0&id=63a1d8dc&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a1d8dc"]])

export default __exports__